const translations = {
  'en': {
    'alerts': {
      'changedRecommendation': 'Recommendation Changed',
      'addedRecommendation': 'Recommendation Added',
      'submittedAdverseReaction': 'Adverse Reaction Submitted',
      'addedShot': 'Immunization Added',
      'addedPatient': 'Patient Added'
    },
    'pathologies': {
      'hepatitis_b': 'Hepatitis B',
      'hib': 'Hib',
      'diphtheria': 'Diphtheria',
      'tetanus': 'Tetanus',
      'pertussis': 'Pertussis',
      'poliomyelitis': 'Poliomyelitis',
      'pneumococcal_disease': 'Pneumococcal Disease',
      'meningococcal_infection': 'Meningoloccal Infection',
      'measles': 'Measles',
      'mumps': 'Mumps',
      'rubella': 'Rubella',
      'uterine_cancer': 'Uterine Cancer',
      'varicella': 'Varicella',
      'influenza': 'Influenza',
      'rotavirus': 'Rotavirus',
      'tuberculosis': 'Tuberculosis',
      'japanese_encephalitis': 'Japanese Encephalitis',
      'cholera': 'Cholera',
      'yellow_fever': 'Yellow Fever',
      'typhoid_fever': 'Typhoid Fever',
      'hepatitis_a': 'Hepatitis A',
      'rabies': 'Rabies'
    },
    'timing': {
      'numDays': '%{smart_count} Day |||| %{smart_count} Days',
      'numWeeks': '%{smart_count} Week |||| %{smart_count} Weeks',
      'numMonths': '%{smart_count} Month |||| %{smart_count} Months',
      'numYears': '%{smart_count} Year |||| %{smart_count} Years',
      'numSeconds': '%{smart_count} Second |||| %{smart_count} Seconds',
      'numMinutes': '%{smart_count} Minute |||| %{smart_count} Minutes',
      'numHours': '%{smart_count} Hour |||| %{smart_count} Hours'
    },
    'demo': {
      'title': 'Demo Version',
      'description': 'The app is in demo version. All changes will be lost on Patient Change.'
    },
    'selectionList': {
      'noElements': 'No elements'
    },
    'login': {
      'enter': 'Enter'
    },
    'settings': {
      'general': 'General',
      'languageSelect': 'Language Select',
      'save': 'Change'
    },
    'menu': {
      'patients': 'Patients',
      'vaccinationPlan': 'Vaccination Plan',
      'search': 'Search',
      'settings': 'Settings',
      'profile': 'Profile',
      'logout': 'Logout',
      'mainView': 'Main View',
      'planEdit': 'Plan Edition',
      'receipt': 'Receipt',
      'administrativeInsertion': 'Administrative Insertion'
    },
    'vaccinationPlan': {
      'vaccinationPlan': 'Vaccination Plan'
    },
    'patientList': {
      'patient': 'Patient',
      'recent': 'Recent'
    },
    'searchForm': {
      'recent': 'Recent',
      'id': 'ID',
      'searchPatient': 'Search Patient'
    },
    'patientViewer': {
      'addVaccine': 'Add Vaccine',
      'addPreviousImmunization': 'Add Previous Immunization',
      'barcode': 'Barcode',
      'addImmunoglobulin': 'Add Immunoglobulin'
    },
    'immunizationInsertion': {
      'pathologies': 'Pathologies',
      'vaccines': 'Vaccines',
      'immunoglobulins': 'Immunoglobulins',
      'batch': 'Batch',
      'observations': 'Observations',
      'observationsPlaceholder': 'Observations',
      'adverseReactionAttentionMessage': 'This information will be sent to the Medicines & Healthcare products Regulatory Agency (MHRA).\nPlease, verify carefully all answers before you submit.',
      'adverseReactions': 'Adverse Reactions',
      'positiveAnswer': 'Yes',
      'negativeAnswer': 'No',
      'submit': 'Submit',
      'adverseReaction': 'Adverse Reaction',
      'description': 'Description',
      'descriptionPlaceholder': 'Description',
      'start': 'Date beginning',
      'end': 'Date end',
      'reactionType': 'Reaction Type',
      'lifeInRisc': 'Was Life-threatening',
      'congenitalAnomalies': 'Caused congenital anomalies',
      'motivatedOrProlongedHospitalization': 'Caused or prolonged hospitalization',
      'significantIncapacities': 'Resulted in significant disability',
      'death': 'Resulted in death',
      'other': 'Other serious adverse event: specify',
      'detailsOfReaction': 'Do you want to insert adverse reaction details?',
      'reactionDetails': 'Reaction Details',
      'suspendedDueToReaction': 'Vaccine was suspended because of the Adverse event',
      'improvedAfterSuspension': 'Condition improved after suspension',
      'noChange': 'Condition persisted after suspension',
      'reductionOfPosology': 'There was dosage reduction',
      'reactionSuspitionBetweenDrugs': 'Drug interaction suspected',
      'reintroduced': 'Vaccination was resumed',
      'sameReactionAfterReintroduction': 'A similar adverse reaction occured after vaccination was resumed.',
      'previousReactionToSameVaccine': 'There are previously known adverse reactions to this vaccine',
      'previousReactionToOtherDrugs': 'There are previously known adverse reactions to other drugs',
      'casualityRelation': 'The causal relationship is considered',
      'definitive': 'Definitive (certain)',
      'probable': 'Likely',
      'possible': 'Possible',
      'unlikely': 'Unlikely',
      'immunization': 'Immunization',
      'vaccineInsertion': 'Vaccine Insertion',
      'immunoglobulinInsertion': 'Immunoglobulin Insertion',
      'vaccine': 'Vaccine',
      'immunoglobulin': 'Immunoglobulin'
    },
    'detailedImmunization': {
      'administrationDate': 'Administration Date',
      'observations': 'Observations',
      'withoutObservations': 'Without Observations',
      'applicablePathologies': 'Targeted Diseases',
      'adverseReaction': 'Adverse Reaction',
      'withoutAdverseReaction': 'Without Adverse Reaction'
    },
    'immunizationBox': {
      'date': 'Date',
      'observations': 'Observations',
      'noObservations': 'Without Observations',
      'immunization': 'Immunization',
      'adverseReaction': 'Adverse Reaction',
      'immunoglobulin': 'Immunoglobulin'
    },
    'pathologyBox': {
      'day': 'Day',
      'days': 'Days',
      'weeks': 'Weeks',
      'months': 'Months',
      'shots': 'Shots'
    },
    'plannedShotBox': {
      'years': 'Years',
      'months': 'Months',
      'days': 'Days',
      'doseNumber': 'Shot number'
    },
    'recommendationBox': {
      'doseNumber': 'Shot number'
    },
    'pathologiesGrid': {
      'noImmunizations': 'There are no Immunizations',
      'loadingPathologies': 'Loading Pathologies'
    },
    'patientHeader': {
      'patient': 'Patient',
      'age': 'Age'
    },
    'receipt': {
      'openNewTab': 'Open in new Tab',
      'missing': 'Missing',
      'predicted': 'Predicted',
      'vaccineRegistry': 'Vaccine Registry',
      'name': 'Name',
      'birthDate': 'Birth Date',
      'age': 'Age',
      'userNumber': 'User Number',
      'nextImmunizations': 'Next Immunizations',
      'currentImmunizations': 'Current Immunizations',
      'numberOfShot': 'Shot N:',
      'immunoglobulin': 'Immunoglobulin'
    },
    'profile': {
      'medicalStaffProfile': 'Medical Staff Profile',
      'professionalCertificate': 'Professional Certificate N: ',
      'location': 'Location (Vaccination Center)',
      'landNumber': 'Phone Number',
      'mobileNumber': 'Mobile Phone Number',
      'email': 'E-mail',
      'doctorMale': 'Doctor',
      'nurseMale': 'Nurse',
      'pharmaceuticalMale': 'Pharmaceutical',
      'doctorFemale': 'Doctor',
      'nurseFemale': 'Nurse',
      'pharmaceuticalFemale': 'Pharmaceutical',
      'noneMale': 'Mr.',
      'noneFemale': 'Ms.'
    },
    'documentType': {
      'details': 'Details',
      'epar': 'EPAR',
      'rcp': 'RCP',
      'fi': 'FI'
    },
    'main': {
      'doctorMale': 'Dr.',
      'nurseMale': 'Nrs.',
      'noneMale': 'Mr.',
      'doctorFemale': 'Dr.',
      'nurseFemale': 'Nrs.',
      'noneFemale': 'Ms.',
      'doctorUniversal': 'Dr.',
      'nurseUniversal': 'Nrs.',
      'noneUniversal': 'Mr./Ms.'
    },
    'recommendationAddition': {
      'newShotInsertion': 'New Shot Insertion',
      'doseNumber': 'Dose Number',
      'earliest': 'Start Date',
      'recommended': 'Recommended Date',
      'latest': 'End Date',
      'submit': 'Submit'
    },
    'recommendationEdit': {
      'editRecommendationTitle': 'Edit Shot',
      'doseNumber': 'Dose Number',
      'earliest': 'Start Date',
      'recommended': 'Recommended Date',
      'latest': 'End Date',
      'submit': 'Submit'
    },
    'administrativeInsertion': {
      'changePatient': 'Change Patient',
      'date': 'Date',
      'pathologies': 'Pathologies',
      'observations': 'Observations',
      'adverseReaction': 'Adverse Reaction',
      'notDefined': 'N/D',
      'positive': 'Yes',
      'negative': 'No',
      'addShot': 'Add Shot',
      'patientNumber': 'Patient Number',
      'submit': 'Submit',
      'insertNewPatient': 'Insert New Patient'
    },
    'patientCreation': {
      'title': 'Create New Patient',
      'patientId': 'Patient Number',
      'patientName': 'Name',
      'birthDate': 'Birth Date',
      'genderMale': 'Male',
      'genderFemale': 'Female',
      'genderOther': 'Other',
      'submitButton': 'Submit'
    }
  },
  'pt': {
    'alerts': {
      'changedRecommendation': 'Recomendação Alterada',
      'addedRecommendation': 'Recomendação Adicionada',
      'submittedAdverseReaction': 'Reação adversa Submetida',
      'addedShot': 'Toma Administrada',
      'addedPatient': 'Utente Adicionado'
    },
    'pathologies': {
      'hepatitis_b': 'Hepatite B',
      'hib': 'Hib',
      'diphtheria': 'Difteria',
      'tetanus': 'Tétano',
      'pertussis': 'Tosse Convulsa',
      'poliomyelitis': 'Poliomielite',
      'pneumococcal_disease': 'Doença Pneumocócica',
      'meningococcal_infection': 'Doença Meningocócica C',
      'measles': 'Sarampo',
      'mumps': 'Parotidite Epidémica',
      'rubella': 'Rubéola',
      'uterine_cancer': 'Cancro Colo do Útero',
      'varicella': 'Varicela',
      'influenza': 'Gripe',
      'rotavirus': 'Rotavírus',
      'tuberculosis': 'Tuberculose',
      'japanese_encephalitis': 'Encefalite Japonesa',
      'cholera': 'Cólera',
      'yellow_fever': 'Febre Amarela',
      'typhoid_fever': 'Febre Tifóide',
      'hepatitis_a': 'Hepatite A',
      'rabies': 'Raiva'
    },
    'timing': {
      'numDays': '%{smart_count} Dia |||| %{smart_count} Dias',
      'numWeeks': '%{smart_count} Semana |||| %{smart_count} Semanas',
      'numMonths': '%{smart_count} Mês |||| %{smart_count} Meses',
      'numYears': '%{smart_count} Ano |||| %{smart_count} Anos',
      'numSeconds': '%{smart_count} Segundo |||| %{smart_count} Segundos',
      'numMinutes': '%{smart_count} Minuto |||| %{smart_count} Minutos',
      'numHours': '%{smart_count} Hora |||| %{smart_count} Horas'
    },
    'demo': {
      'title': 'Versão Demonstração',
      'description': 'Esta é uma versão de demonstração. Qualquer alteração será apagada após a troca do Paciente selecionado.'
    },
    'selectionList': {
      'noElements': 'Sem elementos'
    },
    'login': {
      'enter': 'Entrar'
    },
    'menu': {
      'patients': 'Utentes',
      'vaccinationPlan': 'Plano de Vacinação',
      'search': 'Pesquisa',
      'settings': 'Definições',
      'profile': 'Perfil',
      'logout': 'Sair',
      'mainView': 'Vista Principal',
      'planEdit': 'Editar Plano',
      'receipt': 'Recibo',
      'administrativeInsertion': 'Inserção Administrativa'
    },
    'vaccinationPlan': {
      'vaccinationPlan': 'Plano de Vacinação'
    },
    'settings': {
      'general': 'Geral',
      'languageSelect': 'Selecionar Língua',
      'save': 'Alterar'
    },
    'patientList': {
      'patient': 'Utente',
      'recent': 'Recente'
    },
    'searchForm': {
      'recent': 'Recente',
      'id': 'ID',
      'searchPatient': 'Pesquisar Utente'
    },
    'patientViewer': {
      'addVaccine': 'Adicionar Vacina',
      'addPreviousImmunization': 'Adicionar Imunização Prévia',
      'barcode': 'Código de Barras',
      'addImmunoglobulin': 'Adicionar Imunoglobulina'
    },
    'immunizationInsertion': {
      'pathologies': 'Patologias',
      'vaccines': 'Vacinas',
      'immunoglobulins': 'Imunoglobulinas',
      'batch': 'Lote',
      'observations': 'Observações',
      'observationsPlaceholder': 'Observações',
      'adverseReactionAttentionMessage': 'Esta informação será enviada para o Infarmed.\nVerifique cuidadosamente todas as respostas antes de submeter.',
      'adverseReactions': 'Reações Adversas',
      'positiveAnswer': 'Sim',
      'negativeAnswer': 'Não',
      'submit': 'Submeter',
      'adverseReaction': 'Reação Adversa',
      'description': 'Descrição',
      'descriptionPlaceholder': 'Descrição',
      'start': 'Data Início',
      'end': 'Data Fim',
      'reactionDetails': 'Detalhes da Reação',
      'vaccineInsertion': 'Inserção de Vacina',
      'immunoglobulinInsertion': 'Inserção de Imunoglobulina',
      'vaccine': 'Vacina',
      'immunoglobulin': 'Imunoglobulina',
      'reactionType': 'Tipo de Reação',
      'lifeInRisc': 'Colocou a Vida em Risco',
      'congenitalAnomalies': 'Causou Anomalias Congénitas',
      'motivatedOrProlongedHospitalization': 'Motivou ou Prolongou Internamento\'',
      'significantIncapacities': 'Resultou em Incapacidades Significativas',
      'death': 'Resultou em Morte',
      'other': 'Outra: Especifique',
      'detailsOfReaction': 'Detalhes de Reação',
      'suspendedDueToReaction': 'A vacina foi suspensa devido à reação',
      'improvedAfterSuspension': 'A reação melhorou após a suspensão',
      'noChange': 'A reação manteve-se',
      'reductionOfPosology': 'Houve redução da posologia',
      'reactionSuspitionBetweenDrugs': 'Suspeita de interação entre medicamentos',
      'reintroduced': 'A vacina foi reintroduzida',
      'sameReactionAfterReintroduction': 'Ocorreu reação adversa idêntica após a reintrodução',
      'previousReactionToSameVaccine': 'São conhecidas reacções anteriores à mesma vacina',
      'previousReactionToOtherDrugs': 'São conhecidas reacções anteriores a outros fármacos',
      'casualityRelation': 'A relação de causalidade é considerada',
      'definitive': 'Definitiva (certa)',
      'probable': 'Provável',
      'possible': 'Possível',
      'unlikely': 'Improvável',
      'immunization': 'Imunização'
    },
    'detailedImmunization': {
      'administrationDate': 'Data da Administração',
      'observations': 'Observações',
      'withoutObservations': 'Sem Observações',
      'applicablePathologies': 'Patologias Alvo',
      'adverseReaction': 'Reação Adversa',
      'withoutAdverseReaction': 'Sem Reação Adversa'
    },
    'immunizationBox': {
      'date': 'Data',
      'observations': 'Observações',
      'noObservations': 'Sem Observações',
      'immunization': 'Imunização',
      'adverseReaction': 'Reação Adversa',
      'immunoglobulin': 'Imunoglobulina'
    },
    'pathologyBox': {
      'day': 'Dia',
      'days': 'Dias',
      'weeks': 'Semana',
      'months': 'Meses',
      'shots': 'Tomas'
    },
    'plannedShotBox': {
      'years': 'Anos',
      'months': 'Meses',
      'days': 'Dias',
      'doseNumber': 'Toma nº'
    },
    'recommendationBox': {
      'doseNumber': 'Toma nº'
    },
    'pathologiesGrid': {
      'noImmunizations': 'Sem imunizações',
      'loadingPathologies': 'A carregar as patologias...'
    },
    'patientHeader': {
      'patient': 'Utente',
      'age': 'Idade'
    },
    'receipt': {
      'openNewTab': 'Abrir num novo separador',
      'missing': 'Falta',
      'predicted': 'Prevista',
      'vaccineRegistry': 'Registo de Vacinas',
      'name': 'Nome',
      'birthDate': 'Data Nascimento',
      'age': 'Idade',
      'userNumber': 'Nº Utente',
      'nextImmunizations': 'Próximas Imunizações',
      'currentImmunizations': 'Imunizações atuais',
      'numberOfShot': 'Toma Nº',
      'immunoglobulin': 'Imunoglobulina'
    },
    'profile': {
      'medicalStaffProfile': 'Perfil do Profissional',
      'professionalCertificate': 'Cédula Profissional',
      'location': 'Local (Centro de Vacinação)',
      'landNumber': 'Telefone fixo',
      'mobileNumber': 'Telemóvel',
      'email': 'E-mail',
      'doctorMale': 'Médico',
      'nurseMale': 'Enfermeiro',
      'pharmaceuticalMale': 'Farmacêutico',
      'doctorFemale': 'Médica',
      'nurseFemale': 'Enfermeira',
      'pharmaceuticalFemale': 'Farmacêutica',
      'noneMale': 'Sr.',
      'noneFemale': 'Sra.'
    },
    'documentType': {
      'details': 'Detalhes',
      'epar': 'EPAR',
      'rcp': 'RCP',
      'fi': 'FI'
    },
    'main': {
      'doctorMale': 'Dr.',
      'nurseMale': 'Enf.',
      'noneMale': 'Sr.',
      'doctorFemale': 'Dra.',
      'nurseFemale': 'Enf.',
      'noneFemale': 'Sra.',
      'doctorUniversal': 'Dr./Dra.',
      'nurseUniversal': 'Enf.',
      'noneUniversal': 'Sr./Sra.'
    },
    'recommendationAddition': {
      'newShotInsertion': 'Inserção de Nova Toma',
      'doseNumber': 'Número de Toma',
      'earliest': 'Data Início',
      'recommended': 'Data Recomendada',
      'latest': 'Data Fim',
      'submit': 'Adicionar'
    },
    'recommendationEdit': {
      'editRecommendationTitle': 'Editar Toma',
      'doseNumber': 'Número de Toma',
      'earliest': 'Data Início',
      'recommended': 'Data Recomendada',
      'latest': 'Data Fim',
      'submit': 'Alterar'
    },
    'administrativeInsertion': {
      'changePatient': 'Trocar de Utente',
      'date': 'Data',
      'pathologies': 'Patologias',
      'observations': 'Observações',
      'adverseReaction': 'Reação Adversa',
      'notDefined': 'N/D',
      'positive': 'Sim',
      'negative': 'Não',
      'addShot': 'Adicionar Toma',
      'patientNumber': 'Nº Utente',
      'submit': 'Consultar Utente',
      'insertNewPatient': 'Adicionar Utente'
    },
    'patientCreation': {
      'title': 'Adicionar Novo Utente',
      'patientId': 'Número de Utente',
      'patientName': 'Nome',
      'birthDate': 'Date de Nascimento',
      'genderMale': 'Masculino',
      'genderFemale': 'Feminino',
      'genderOther': 'Outro',
      'submitButton': 'Adicionar'
    }
  },
  'de': {
    'alerts': {
      'changedRecommendation': 'Empfehlung geändert',
      'addedRecommendation': 'Empfehlung hinzugefügt',
      'submittedAdverseReaction': 'Unerwünschte Reaktion eingereicht',
      'addedShot': 'Immunisierung hinzugefügt',
      'addedPatient': 'Patient hinzugefügt'
    },
    'pathologies': {
      'hepatitis_b': 'Hepatitis B',
      'hib': 'Hib',
      'diphtheria': 'Diphtherie',
      'tetanus': 'Tetanus',
      'pertussis': 'Pertussis',
      'poliomyelitis': 'Polio',
      'pneumococcal_disease': 'Pneumokokken',
      'meningococcal_infection': 'Meningokokken C',
      'measles': 'Masern',
      'mumps': 'Mumps',
      'rubella': 'Röteln',
      'uterine_cancer': 'Gebärmutterhalskrebs',
      'varicella': 'Varizellen',
      'influenza': 'Grippe',
      'rotavirus': 'Rotavirus',
      'tuberculosis': 'Tuberkulose',
      'japanese_encephalitis': 'Japanische Enzephalitis',
      'cholera': 'Cholera',
      'yellow_fever': 'Gelbfieber',
      'typhoid_fever': 'Typhus-Fieber',
      'hepatitis_a': 'Hepatitis A',
      'rabies': 'Tollwut'
    },
    'timing': {
      'numDays': '%{smart_count} Tag |||| %{smart_count} Tage',
      'numWeeks': '%{smart_count} Woche |||| %{smart_count} Wochen',
      'numMonths': '%{smart_count} Monat |||| %{smart_count} Monate',
      'numYears': '%{smart_count} Jahr |||| %{smart_count} Jahre',
      'numSeconds': '%{smart_count} Sekunde |||| %{smart_count} Sekunden',
      'numMinutes': '%{smart_count} Minute |||| %{smart_count} Minuten',
      'numHours': '%{smart_count} Stunde |||| %{smart_count} Stunden'
    },
    'demo': {
      'title': 'Demo Version',
      'description': 'Die App ist in Demo-Version. Alle Änderungen gehen bei Patientenwechsel verloren.'
    },
    'selectionList': {
      'noElements': 'Keine Elemente'
    },
    'login': {
      'enter': 'Eingeben'
    },
    'settings': {
      'general': 'General',
      'languageSelect': 'Sprache Auswählen',
      'save': 'Ändern'
    },
    'menu': {
      'patients': 'Patienten',
      'vaccinationPlan': 'Impfplan',
      'search': 'Suche',
      'settings': 'Einstellungen',
      'profile': 'Profil',
      'logout': 'Ausloggen',
      'mainView': 'Hauptansicht',
      'planEdit': 'Plan Bearbeiten',
      'receipt': 'Eingang',
      'administrativeInsertion': 'Administrative Einfügung'
    },
    'vaccinationPlan': {
      'vaccinationPlan': 'Impfplan'
    },
    'patientList': {
      'patient': 'Patient',
      'recent': 'Neueste'
    },
    'searchForm': {
      'recent': 'Neueste',
      'id': 'ID',
      'searchPatient': 'Patient Suchen'
    },
    'patientViewer': {
      'addVaccine': 'Impfstoff hinzufügen',
      'addPreviousImmunization': 'Vorherige Immunisierung hinzufügen',
      'barcode': 'Barcode',
      'addImmunoglobulin': 'Füge Immunglobulin hinzu'
    },
    'immunizationInsertion': {
      'pathologies': 'Pathologien',
      'vaccines': 'Impfstoffe',
      'immunoglobulins': 'Immunglobuline',
      'batch': 'Stapel',
      'observations': 'Beobachtungen',
      'observationsPlaceholder': 'Beobachtungen',
      'adverseReactionAttentionMessage': 'Das Bundesinstitut für Arzneimittel und Medizinprodukte (BfArM) wird über diese unerwünschte Arzneimittelreaktion informiert.',
      'adverseReactions': 'Nebenwirkungen',
      'positiveAnswer': 'Ja',
      'negativeAnswer': 'Nein',
      'submit': 'Einreichen',
      'adverseReaction': 'Nebenwirkung',
      'description': 'Beschreibung',
      'descriptionPlaceholder': 'Beschreibung',
      'start': 'Datum beginnt',
      'end': 'Datum ende',
      'reactionType': 'Reaktionstyp',
      'lifeInRisc': 'War lebensbedrohlich',
      'congenitalAnomalies': 'Verursacht angeborene Anomalien',
      'motivatedOrProlongedHospitalization': 'Verursachter oder längerer Krankenhausaufenthalt',
      'significantIncapacities': 'Ergebnis einer erheblichen Behinderung',
      'death': 'Zum Tod geführt',
      'other': 'Andere schwerwiegende Nebenwirkungen: Angeben',
      'detailsOfReaction': 'Möchten Sie Nebenwirkungen einfügen?',
      'reactionDetails': 'Reaktionsdetails',
      'suspendedDueToReaction': 'Der Impfstoff wurde wegen der Nebenwirkung suspendiert',
      'improvedAfterSuspension': 'Zustand nach Aufhängung verbessert',
      'noChange': 'Zustand nach Suspension beständig',
      'reductionOfPosology': 'Es gab eine Dosisreduktion',
      'reactionSuspitionBetweenDrugs': 'Wechselwirkung vermutet',
      'reintroduced': 'Die Impfung wurde wieder aufgenommen',
      'sameReactionAfterReintroduction': 'Eine ähnliche Nebenwirkung wurde nach der Impfung wieder aufgenommen.',
      'previousReactionToSameVaccine': 'Es gibt bereits bekannte Nebenwirkungen dieses Impfstoffs',
      'previousReactionToOtherDrugs': 'Es gibt vorherige bekannte Nebenwirkungen auf andere Medikamente',
      'casualityRelation': 'Ein Kausalzusammenhang wird angenommen',
      'definitive': 'Definitive (bestimmte)',
      'probable': 'Wahrscheinlich',
      'possible': 'Möglich',
      'unlikely': 'Unwahrscheinlich',
      'immunization': 'Immunisierung',
      'vaccineInsertion': 'Impfstoffinsertion',
      'immunoglobulinInsertion': 'Immunglobulin-Insertion',
      'vaccine': 'Impfstoff',
      'immunoglobulin': 'Immunoglobulin'
    },
    'detailedImmunization': {
      'administrationDate': 'Verwaltungsdatum',
      'observations': 'Beobachtungen',
      'withoutObservations': 'Ohne Beobachtungen',
      'applicablePathologies': 'Zielgerichtete Krankheiten',
      'adverseReaction': 'Unerwünschte Reaktion',
      'withoutAdverseReaction': 'Ohne Nachteilige Reaktion'
    },
    'immunizationBox': {
      'date': 'Datum',
      'observations': 'Beobachtungen',
      'noObservations': 'Ohne Beobachtungen',
      'immunization': 'Immunisierung',
      'adverseReaction': 'Unerwünschte Reaktion',
      'immunoglobulin': 'Immunoglobulin'
    },
    'pathologyBox': {
      'day': 'Tag',
      'days': 'Tage',
      'weeks': 'Wochen',
      'months': 'Monate',
      'shots': 'Schüsse'
    },
    'plannedShotBox': {
      'years': 'Jahre',
      'months': 'Monate',
      'days': 'Tage',
      'doseNumber': 'Schuss n'
    },
    'recommendationBox': {
      'doseNumber': 'Schuss n'
    },
    'pathologiesGrid': {
      'noImmunizations': 'Es gibt keine Impfungen',
      'loadingPathologies': 'Pathologien laden'
    },
    'patientHeader': {
      'patient': 'Patient',
      'age': 'Alter'
    },
    'receipt': {
      'openNewTab': 'In neuem Tab öffnen',
      'missing': 'Fehlt',
      'predicted': 'Vorhergesagt',
      'vaccineRegistry': 'Impfstoffregister',
      'name': 'Name',
      'birthDate': 'Geburtstag',
      'age': 'Alter',
      'userNumber': 'Benutzernummer',
      'nextImmunizations': 'Nächste Impfungen',
      'currentImmunizations': 'Aktuelle Immunisierungen',
      'numberOfShot': 'Schuss Nr. ',
      'immunoglobulin': 'Immunoglobulin'
    },
    'profile': {
      'medicalStaffProfile': 'Profil des Medizinischen Personals',
      'professionalCertificate': 'Berufszertifikatsnummer:',
      'location': 'Ort (Impfzentrum)',
      'landNumber': 'Telefonnummer',
      'mobileNumber': 'Handynummer',
      'email': 'E-mail',
      'doctorMale': 'Doktor',
      'nurseMale': 'Krankenschwester',
      'pharmaceuticalMale': 'Pharmazeutisch',
      'doctorFemale': 'Doktor',
      'nurseFemale': 'Krankenschwester',
      'pharmaceuticalFemale': 'Pharmaceutical',
      'noneMale': 'Hr.',
      'noneFemale': 'Fr.'
    },
    'documentType': {
      'details': 'Details',
      'epar': 'EPAR',
      'rcp': 'RCP',
      'fi': 'FI'
    },
    'main': {
      'doctorMale': 'Dr.',
      'nurseMale': 'Kr.',
      'noneMale': 'Hr.',
      'doctorFemale': 'Dr.',
      'nurseFemale': 'Kr.',
      'noneFemale': 'Fr.',
      'doctorUniversal': 'Dr.',
      'nurseUniversal': 'Kr.',
      'noneUniversal': 'Hr./Fr.'
    },
    'recommendationAddition': {
      'newShotInsertion': 'Einfügen eines neuen Schusses',
      'doseNumber': 'Dosis Nummer',
      'earliest': 'Anfangsdatum',
      'recommended': 'Empfohlenes Datum',
      'latest': 'Endtermin',
      'submit': 'Einreichen'
    },
    'recommendationEdit': {
      'editRecommendationTitle': 'Bearbeiten Nehmen',
      'doseNumber': 'Dosis Nummer',
      'earliest': 'Anfangsdatum',
      'recommended': 'Empfohlenes Datum',
      'latest': 'Endtermin',
      'submit': 'Einreichen'
    },
    'administrativeInsertion': {
      'changePatient': 'Patienten wechseln',
      'date': 'Datum',
      'pathologies': 'Pathologien',
      'observations': 'Beobachtungen',
      'adverseReaction': 'Unerwünschte Reaktion',
      'notDefined': 'N/D',
      'positive': 'Ja',
      'negative': 'Nein',
      'addShot': 'Immunisierung Hinzufügen',
      'patientNumber': 'Patientennummer',
      'submit': 'Einreichen',
      'insertNewPatient': 'Neuen Patienten Einfügen'
    },
    'patientCreation': {
      'title': 'Neuen Patienten Anlegen',
      'patientId': 'Patientennummer',
      'patientName': 'Name',
      'birthDate': 'Geburtstag',
      'genderMale': 'Männlich',
      'genderFemale': 'Weiblich',
      'genderOther': 'Andere',
      'submitButton': 'Einreichen'
    }
  },
  'br': {
    'alerts': {
      'changedRecommendation': 'Recomendação Alterada',
      'addedRecommendation': 'Recomendação Adicionada',
      'submittedAdverseReaction': 'Reação adversa Submetida',
      'addedShot': 'Toma Administrada',
      'addedPatient': 'Paciente Adicionado'
    },
    'pathologies': {
      'hepatitis_b': 'Hepatite B',
      'hib': 'Hib',
      'diphtheria': 'Difteria',
      'tetanus': 'Tétano',
      'pertussis': 'Tosse Convulsa',
      'poliomyelitis': 'Poliomielite',
      'pneumococcal_disease': 'Doença Pneumocócica',
      'meningococcal_infection': 'Doença Meningocócica C',
      'measles': 'Sarampo',
      'mumps': 'Parotidite Epidémica',
      'rubella': 'Rubéola',
      'uterine_cancer': 'Cancro Colo do Útero',
      'varicella': 'Varicela',
      'influenza': 'Gripe',
      'rotavirus': 'Rotavírus',
      'tuberculosis': 'Tuberculose',
      'japanese_encephalitis': 'Encefalite Japonesa',
      'cholera': 'Cólera',
      'yellow_fever': 'Febre Amarela',
      'typhoid_fever': 'Febre Tifóide',
      'hepatitis_a': 'Hepatite A',
      'rabies': 'Raiva'

    },
    'timing': {
      'numDays': '%{smart_count} Dia |||| %{smart_count} Dias',
      'numWeeks': '%{smart_count} Semana |||| %{smart_count} Semanas',
      'numMonths': '%{smart_count} Mês |||| %{smart_count} Meses',
      'numYears': '%{smart_count} Ano |||| %{smart_count} Anos',
      'numSeconds': '%{smart_count} Segundo |||| %{smart_count} Segundos',
      'numMinutes': '%{smart_count} Minuto |||| %{smart_count} Minutos',
      'numHours': '%{smart_count} Hora |||| %{smart_count} Horas'
    },
    'demo': {
      'title': 'Versão Demonstração',
      'description': 'Esta é uma versão de demonstração. Qualquer alteração será apagada após a troca do Paciente selecionado.'
    },
    'selectionList': {
      'noElements': 'Sem elementos'
    },
    'login': {
      'enter': 'Entrar'
    },
    'menu': {
      'patients': 'Pacientes',
      'vaccinationPlan': 'Plano de Vacinação',
      'search': 'Pesquisa',
      'settings': 'Definições',
      'profile': 'Perfil',
      'logout': 'Sair',
      'mainView': 'Vista Principal',
      'planEdit': 'Editar Plano',
      'receipt': 'Recibo',
      'administrativeInsertion': 'Inserção Administrativa'
    },
    'vaccinationPlan': {
      'vaccinationPlan': 'Plano de Vacinação'
    },
    'settings': {
      'general': 'Geral',
      'languageSelect': 'Selecionar Língua',
      'save': 'Alterar'
    },
    'patientList': {
      'patient': 'Paciente',
      'recent': 'Recente'
    },
    'searchForm': {
      'recent': 'Recente',
      'id': 'ID',
      'searchPatient': 'Pesquisar Paciente'
    },
    'patientViewer': {
      'addVaccine': 'Adicionar Vacina',
      'addPreviousImmunization': 'Adicionar Imunização Prévia',
      'barcode': 'Código de Barras',
      'addImmunoglobulin': 'Adicionar Imunoglobulina'
    },
    'immunizationInsertion': {
      'pathologies': 'Patologias',
      'vaccines': 'Vacinas',
      'immunoglobulins': 'Imunoglobulinas',
      'batch': 'Lote',
      'observations': 'Observações',
      'observationsPlaceholder': 'Observações',
      'adverseReactionAttentionMessage': 'Esta informação será enviada para o ANVISA.\nVerifique cuidadosamente todas as respostas antes de submeter.',
      'adverseReactions': 'Reações Adversas',
      'positiveAnswer': 'Sim',
      'negativeAnswer': 'Não',
      'submit': 'Submeter',
      'adverseReaction': 'Reação Adversa',
      'description': 'Descrição',
      'descriptionPlaceholder': 'Descrição',
      'start': 'Data Início',
      'end': 'Data Fim',
      'reactionDetails': 'Detalhes da Reação',
      'vaccineInsertion': 'Inserção de Vacina',
      'immunoglobulinInsertion': 'Inserção de Imunoglobulina',
      'vaccine': 'Vacina',
      'immunoglobulin': 'Imunoglobulina',
      'reactionType': 'Tipo de Reação',
      'lifeInRisc': 'Colocou a Vida em Risco',
      'congenitalAnomalies': 'Causou Anomalias Congénitas',
      'motivatedOrProlongedHospitalization': 'Motivou ou Prolongou Internamento',
      'significantIncapacities': 'Resultou em Incapacidades Significativas',
      'death': 'Resultou em Morte',
      'other': 'Outra: Especifique',
      'detailsOfReaction': 'Detalhes de Reação',
      'suspendedDueToReaction': 'A vacina foi suspensa devido à reação',
      'improvedAfterSuspension': 'A reação melhorou após a suspensão',
      'noChange': 'A reação manteve-se',
      'reductionOfPosology': 'Houve redução da posologia',
      'reactionSuspitionBetweenDrugs': 'Suspeita de interação entre medicamentos',
      'reintroduced': 'A vacina foi reintroduzida',
      'sameReactionAfterReintroduction': 'Ocorreu reação adversa idêntica após a reintrodução',
      'previousReactionToSameVaccine': 'São conhecidas reacções anteriores à mesma vacina',
      'previousReactionToOtherDrugs': 'São conhecidas reacções anteriores a outros fármacos',
      'casualityRelation': 'A relação de causalidade é considerada',
      'definitive': 'Definitiva (certa)',
      'probable': 'Provável',
      'possible': 'Possível',
      'unlikely': 'Improvável',
      'immunization': 'Imunização'
    },
    'detailedImmunization': {
      'administrationDate': 'Data da Administração',
      'observations': 'Observações',
      'withoutObservations': 'Sem Observações',
      'applicablePathologies': 'Patologias Alvo',
      'adverseReaction': 'Reação Adversa',
      'withoutAdverseReaction': 'Sem Reação Adversa'
    },
    'immunizationBox': {
      'date': 'Data',
      'observations': 'Observações',
      'noObservations': 'Sem Observações',
      'immunization': 'Imunização',
      'adverseReaction': 'Reação Adversa',
      'immunoglobulin': 'Imunoglobulina'
    },
    'pathologyBox': {
      'day': 'Dia',
      'days': 'Dias',
      'weeks': 'Semana',
      'months': 'Meses',
      'shots': 'Tomas'
    },
    'plannedShotBox': {
      'years': 'Anos',
      'months': 'Meses',
      'days': 'Dias',
      'doseNumber': 'Toma nº'
    },
    'recommendationBox': {
      'doseNumber': 'Toma nº'
    },
    'pathologiesGrid': {
      'noImmunizations': 'Sem imunizações',
      'loadingPathologies': 'A carregar as patologias...'
    },
    'patientHeader': {
      'patient': 'Paciente',
      'age': 'Idade'
    },
    'receipt': {
      'openNewTab': 'Abrir num novo separador',
      'missing': 'Falta',
      'predicted': 'Prevista',
      'vaccineRegistry': 'Registro de Vacinas',
      'name': 'Nome',
      'birthDate': 'Data Nascimento',
      'age': 'Idade',
      'userNumber': 'Nº Usuário',
      'nextImmunizations': 'Próximas Imunizações',
      'currentImmunizations': 'Imunizações atuais',
      'numberOfShot': 'Toma Nº',
      'immunoglobulin': 'Imunoglobulina'
    },
    'profile': {
      'medicalStaffProfile': 'Perfil do Profissional',
      'professionalCertificate': 'Cédula Profissional',
      'location': 'Local (Centro de Vacinação)',
      'landNumber': 'Telefone fixo',
      'mobileNumber': 'Celular',
      'email': 'E-mail',
      'doctorMale': 'Médico',
      'nurseMale': 'Enfermeiro',
      'pharmaceuticalMale': 'Farmacêutico',
      'doctorFemale': 'Médica',
      'nurseFemale': 'Enfermeira',
      'pharmaceuticalFemale': 'Pharmazeutisch',
      'noneMale': 'Sr.',
      'noneFemale': 'Sra.'
    },
    'documentType': {
      'details': 'Detalhes',
      'epar': 'EPAR',
      'rcp': 'RCP',
      'fi': 'FI'
    },
    'main': {
      'doctorMale': 'Dr.',
      'nurseMale': 'Enf.',
      'noneMale': 'Sr.',
      'doctorFemale': 'Dra.',
      'nurseFemale': 'Enf.',
      'noneFemale': 'Sra.',
      'doctorUniversal': 'Dr./Dra.',
      'nurseUniversal': 'Enf.',
      'noneUniversal': 'Sr./Sra.'
    },
    'recommendationAddition': {
      'newShotInsertion': 'Inserção de Nova Toma',
      'doseNumber': 'Número de Dose',
      'earliest': 'Data Início',
      'recommended': 'Data Recomendada',
      'latest': 'Data Fim',
      'submit': 'Submeter'
    },
    'recommendationEdit': {
      'editRecommendationTitle': 'Editar Toma',
      'doseNumber': 'Número de Dose',
      'earliest': 'Data Início',
      'recommended': 'Data Recomendada',
      'latest': 'Data Fim',
      'submit': 'Submeter'
    },
    'administrativeInsertion': {
      'changePatient': 'Trocar Utente',
      'date': 'Data',
      'pathologies': 'Patologias',
      'observations': 'Observações',
      'adverseReaction': 'Reacção Adversa',
      'notDefined': 'N/D',
      'positive': 'Sim',
      'negative': 'Não',
      'addShot': 'Adicionar Toma',
      'patientNumber': 'Nº Utente',
      'submit': 'Consultar',
      'insertNewPatient': 'Adicionar Novo Utente'
    },
    'patientCreation': {
      'title': 'Adicionar Novo Paciente',
      'patientId': 'Número de Paciente',
      'patientName': 'Nome',
      'birthDate': 'Date de Nascimento',
      'genderMale': 'Masculino',
      'genderFemale': 'Feminino',
      'genderOther': 'Outro',
      'submitButton': 'Adicionar'
    }
  }
}

export function getLocale () {
  const languages = window.navigator.languages
  let locale = 'en'
  if (languages) {
    for (let lang of languages) {
      const currLocale = lang.split('-')[0]
      if (translations[currLocale] !== undefined) {
        locale = currLocale
        break
      }
    }
  } else {
    locale = window.navigator.language
  }
  return locale
}

export function getPhrases (locale) {
  if (translations[locale]) {
    return translations[locale]
  } else {
    console.error(`"${locale}" Locale not supported`)
    return translations['en']
  }
}

export default translations
